import React, { useState, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "@ag-grid-community/react";
import { SkeletonDataTable } from "../../Loader/Loader";
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import UserRegistration from "./UserRegistration";
import OnetoOneNotes from "./OnetoOneNotes";
import { Dropdown } from "primereact/dropdown";
import { useTeamlist } from "../../../Hooks/Features/Overview/useTeamList";
import { useCommon } from "../../../Hooks/Common/useCommon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { monthsOpt, yearsOpt } from "../../../utils/Helper";
import DatePicker from "react-multi-date-picker";
import UserMappingWithBranch from "./UserMappingWithBranch";
import CommanDialog from "../../CommonCompo/CommanDialog/CommanDialog";
import ChartConfig from "../ChartConfig/ChartConfig";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import ManagerChangeRequest from "./ManagerChangeRequest";
import CommonFilterDropdown from "../../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule]);


export const TeamList = () => {

    const { tagRef, mapUser, setmapUser, mapRowData, mapColDef, handleUserUpsertHierachy, userMapRef,
        onColumnMoved, onGridReady, loader, rowData, columnDefs, pinnedBottomRowData, gridRef, setShowPopUp, showPopUp, setHandleData, handleData, handleUserActiveRequest, onSortChanged, getTeamOverViewList, categories, userEditData, setUserEditData, showNotes, setShowNotes, notesFlag, setNotesFlag, notesUser, setNotesUser, jiraUser, setJiraUser, groupOpts, jiraAccessValues, setJiraAccessValues, jiraBtnLoader, handleSendJiraAccessRequest, filterValues, setFilterValues, handleExcelDownload, handleEvents, options, mappingPopup, setMappingPopup, addUserPopup, setAddUserPopup, confirmationPopup, setConfirmationPopup, handleSignUp, tab, createChart, setCreateChart, showChangeManager, setShowChangeManager, onFilterChanged, onFilterTextBoxChanged, search, autoGroupColumnDef } = useTeamlist();
    const { checkPermission, getValuePermission } = useCommon();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
    const datePickerRef = useRef(null);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 mb-3 px-3">
                <div className="d-flex align-items-center gap-2 flex-grow-1">
                    <h5 className="mb-0">{tab === "chart" ? "Chart Config" : "Team List"}</h5>
                    <input type="text" id="filter-text-box" placeholder="Search..." onInput={(e) => onFilterTextBoxChanged(e.target.value)} value={search} className='widgets-input input-dd' style={{ maxWidth: "250px" }} />
                </div>
                <div className="d-flex justify-content-end align-items-center gap-2">
                    {tab !== "chart" && <span title="Register User" ref={() => checkPermission('Team overview', tagRef)}>
                        <button ref={tagRef} id='{"tabname": "teamoverview", "data": "team_list_user_register_btn"}' className="sk-btn sk-btn-primary" onClick={() => { setAddUserPopup(true); }}>
                            <FontAwesomeIcon icon="fa-solid fa-add" />
                        </button>
                    </span>}
                    <button
                        className="sk-btn sk-btn-primary"
                        onClick={() => getTeamOverViewList(true)}
                        title="Refresh"
                    >
                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    </button>
                    <button
                        className="sk-btn sk-btn-primary"
                        onClick={() => setShowFiltersDrawer(true)}
                        title="Filters"
                    >
                        <FontAwesomeIcon icon="fa-solid fa-filter" />
                    </button>
                    {tab !== "chart" && <span ref={() => checkPermission('Team overview', tagRef)}>
                        <button ref={tagRef} className="sk-btn sk-btn-primary" title='Team List Excel' onClick={handleExcelDownload} id='{"tabname": "teamoverview", "data": "team_list_excel_btn"}'>
                            <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
                        </button>
                    </span>}

                    {tab !== "chart" && <span ref={() => checkPermission('Team overview', tagRef)}>
                        <button ref={tagRef} className="sk-btn sk-btn-primary" title='Mapping with branch' onClick={() => setMappingPopup(true)} id='{"tabname": "teamoverview", "data": "team_list_map_user_with_unit_btn"}'>
                            <FontAwesomeIcon icon="fa-solid fa-link" />
                        </button>
                    </span>}
                    {tab === "chart" &&
                        <button className="sk-btn sk-btn-primary" onClick={() => { setCreateChart(true); }}>+ Create Chart</button>
                    }
                </div>
            </div>

            {tab !== "chart" ?
                <div className="mt-1">
                    <div className="ag-theme-alpine team-overview-list-grid" style={{ height: 'calc(100vh - 130px)' }}>
                        {
                            loader?.grid ? <SkeletonDataTable numSkeletons={20} /> : <AgGridReact
                                columnDefs={columnDefs}
                                rowData={rowData}
                                ref={gridRef}
                                onSortChanged={() => onSortChanged(gridRef)}
                                pinnedBottomRowData={pinnedBottomRowData}
                                onColumnMoved={onColumnMoved}
                                onGridReady={onGridReady}
                                maintainColumnOrder={true}
                                onFilterChanged={onFilterChanged}
                                autoGroupColumnDef={autoGroupColumnDef}
                                groupDefaultExpanded="-1"
                            />
                        }

                    </div>
                </div>
                :
                <div>
                    <ChartConfig createChart={createChart} setCreateChart={setCreateChart} rowData={rowData} columnDefs={columnDefs} />
                </div>
            }

            <Dialog
                visible={showPopUp}
                header="User Activation Request"
                onHide={() => { setShowPopUp(false); setHandleData((prevState) => ({ ...prevState, remark: '', isRejectClicked: false, decision: '' })) }}
                className="modal-medium"
                draggable={false}
            >
                <div className="dialog-content" style={{ textAlign: 'center' }}>
                    <>
                        <p style={{ fontSize: '16px', marginBottom: '20px', color: '#555' }}>
                            Please select your decision:
                        </p>

                        <div>
                            <label>
                                <input
                                    type="radio"
                                    value="approve"
                                    checked={handleData.decision === 'approve'}
                                    onChange={(e) => setHandleData((prevState) => ({ ...prevState, decision: e.target.value, isRejectClicked: false }))
                                    }
                                    style={{ marginRight: '10px' }}
                                />
                                Approve
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    value="reject"
                                    checked={handleData.decision === 'reject'}
                                    onChange={(e) => setHandleData((prevState) => ({ ...prevState, decision: e.target.value, isRejectClicked: true }))
                                    }
                                    style={{ marginLeft: '20px', marginRight: '10px' }}
                                />
                                Reject
                            </label>
                        </div>

                        {handleData.isRejectClicked && (
                            <>
                                <p style={{ fontSize: '16px', marginBottom: '20px', color: '#555' }}>
                                    Please provide a reason for rejecting the user activation request.
                                </p>
                                <textarea
                                    value={handleData.remark}
                                    onChange={(e) =>
                                        setHandleData((prevState) => ({
                                            ...prevState,
                                            remark: e.target.value,
                                        }))
                                    }
                                    placeholder="Enter your rejection remark"
                                    rows="4"
                                    cols="50"
                                    style={{
                                        padding: '10px',
                                        width: '100%',
                                        fontSize: '14px',
                                        borderRadius: '5px',
                                        borderColor: '#ccc',
                                        marginBottom: '20px'
                                    }}
                                />
                            </>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
                            <button className="button btn-primary" onClick={() => handleUserActiveRequest(handleData.gridData)}> Confirm </button>
                            <button
                                onClick={() => { setShowPopUp(false); setHandleData((prevState) => ({ ...prevState, remark: '', isRejectClicked: false, decision: '' })) }}
                                className="button btn-default"              >
                                Cancel
                            </button>
                        </div>
                    </>
                </div>
            </Dialog>
            <Dialog className="modal-large" header="Map User" style={{ height: "auto" }} draggable={false} visible={mapUser.showPopUp} onHide={() => setmapUser((prevState) => ({
                ...prevState, showPopUp: false,
                selectedUser: [],
                currentUser: { selectedName: "", selectedCode: "" }
            }))} >
                <div>
                    <div className="row">
                        <div className="col-xl-2 col-md-3 col-12 paddr0" style={{ fontSize: 'large', fontWeight: 600 }}>
                            {mapUser?.currentUser?.selectedName}
                        </div>
                        <div className="col-xl-2 col-md-3 col-12 paddr0">
                            <MultiSelect
                                options={mapUser.users}
                                optionLabel="user_display_name"
                                placeholder="Users"
                                value={mapUser.selectedUser}
                                panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'user_display_name', mapUser.selectedUser, () => { }, () => setmapUser((prevState) => ({
                                    ...prevState,
                                    selectedUser: [],
                                })))}
                                onChange={(e) => {
                                    setmapUser((prev) => ({
                                        ...prev, selectedUser: e.target.value
                                    }));
                                }}
                                filter filterInputAutoFocus
                            />
                        </div>
                        <div className="col-xl-2 col-md-4 col-12 paddr0">
                            <button className="btn-primary-new" onClick={() => handleUserUpsertHierachy()}>  Add </button>
                        </div>
                    </div>
                </div>
                <div className="ag-theme-alpine aggrid-container" style={{ height: 'calc(100vh - 389px)' }}>
                    <AgGridReact
                        columnDefs={mapColDef}
                        rowData={mapRowData}
                        rowHeight={30}
                        ref={userMapRef}
                    /></div>
            </Dialog >

            {addUserPopup && <UserRegistration categories={categories?.current} addUserPopup setAddUserPopup={setAddUserPopup} projectLead={options?.leads} getTeamOverViewList={getTeamOverViewList} userEditData={userEditData} resetEditUserData={() => setUserEditData({})} />}
            <Dialog visible={showNotes} onHide={() => { setShowNotes(false); if (notesFlag) { getTeamOverViewList(); setNotesUser({}) } }} draggable={false} header={`One to One Notes - ${notesUser?.user_display_name}`} className="modal-medium">
                <OnetoOneNotes notesUser={notesUser} setNotesFlag={setNotesFlag} />
            </Dialog>
            <Dialog visible={jiraUser?.show} onHide={() => { setJiraUser({ show: false, user: {} }) }} draggable={false} className="modal-xsmall" header={`Send Jira Access request - ${jiraUser?.user?.user_display_name || ""}`}>
                <div>
                    <div>
                        <div>Project: </div>
                        <Dropdown className="input-dd" placeholder="Select Project" options={options?.projects} optionLabel="project_name" value={jiraAccessValues?.project} onChange={(e) => setJiraAccessValues((prev) => ({ ...prev, project: e.target.value }))} filter filterInputAutoFocus showClear />
                    </div>
                    <div className="mt-1">
                        <div>Group: </div>
                        <Dropdown className="input-dd" placeholder="Select Group" options={groupOpts} optionLabel="group_name" value={jiraAccessValues?.group} onChange={(e) => setJiraAccessValues((prev) => ({ ...prev, group: e.target.value }))} filter filterInputAutoFocus showClear />
                    </div>
                    <div className="text-right mt-2">
                        {jiraBtnLoader ?
                            <button className="w20">
                                <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button>
                            :
                            <button className="w20" onClick={() => handleSendJiraAccessRequest()}>Submit</button>
                        }
                    </div>
                </div>
            </Dialog>
            <Dialog visible={mappingPopup} onHide={() => setMappingPopup(false)} className='modal-medium' draggable={false} header={() => <div>User-Unit Mapping</div>}>
                <UserMappingWithBranch />
            </Dialog>
            <CommanDialog visible={confirmationPopup?.show} handleClose={() => setConfirmationPopup({
                data: '',
                show: false
            })} handleFun={handleSignUp} message={`Are you sure you want to send a temporary password to ${confirmationPopup?.data?.user_display_name} ?`} />

            <Dialog visible={showChangeManager?.visible} onHide={() => setShowChangeManager({ visible: false, data: {} })} draggable={false} className="modal-large" style={{ height: "40%" }} header="Request to change Reporting Manager">
                <ManagerChangeRequest options={options} userData={showChangeManager?.data} />
            </Dialog>

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setFilterValues((prev) => ({
                                    ...prev,
                                    day_calendar_groups: [],
                                    projects: [],
                                    users: [],
                                    project_leads: [],
                                    user_technologies: [],
                                    user_status: [],
                                    user_tags: [],
                                    month: null,
                                    year: null,
                                    attribute: [],
                                    unit: [],
                                    isActiveBtn: 'active',
                                    hoveredRange: [],
                                    type: null,
                                    apiCall: true
                                }));
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Date Picker Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Date Range</div>
                                <DatePicker
                                    ref={datePickerRef}
                                    inputClass="input-dd w-100"
                                    style={{ width: "100%" }}
                                    containerStyle={{ width: "100%" }}
                                    value={filterValues?.hoveredRange}
                                    onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValues(prevState => ({ ...prevState, hoveredRange: e, isChange: true }));
                                        if (e && e.length === 2) {
                                            datePickerRef.current?.closeCalendar();
                                        }
                                            }
                                        }}
                                    range
                                    rangeHover
                                    placeholder='Select Date'
                                />
                            </div>

                            {/* Type Filter */}
                            {(filterValues?.hoveredRange?.[0] || filterValues?.hoveredRange?.[1]) && (
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Filter Type</div>
                                    <div className='sk-segment-control mb-3'>
                                        <button
                                            type="button"
                                            className={`sk-segment-btn ${filterValues?.type === 'joining' ? 'active' : ''}`}
                                            onClick={() => setFilterValues(prevState => ({ ...prevState, type: 'joining', apiCall: true }))}
                                        >
                                            Joining
                                        </button>
                                        <button
                                            type="button"
                                            className={`sk-segment-btn ${filterValues?.type === 'resigning' ? 'active' : ''}`}
                                            onClick={() => setFilterValues(prevState => ({ ...prevState, type: 'resigning', apiCall: true }))}
                                        >
                                            Resigning
                                        </button>
                                        <button
                                            type="button"
                                            className={`sk-segment-btn ${filterValues?.type === 'leaving' ? 'active' : ''}`}
                                            onClick={() => setFilterValues(prevState => ({ ...prevState, type: 'leaving', apiCall: true }))}
                                        >
                                            Leave
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Dimensions Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Dimensions</div>
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "day_calendar_groups", label: "Unit", col: 12, isHide: filterValues?.hide_calendar_unit_dropdown || getValuePermission("team_list_unit_dropdown") },
                                        { key: "projects", label: "Projects", col: 12 },
                                        { key: "users", label: "Users", col: 12 },
                                        { key: "project_leads", label: "Leads", col: 12 },
                                        { key: "user_technologies", label: "Technology", col: 12 },
                                        { key: "user_status", label: "Employee Status", col: 12 },
                                        { key: "user_tags", label: "Tags", col: 12 }
                                    ]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues}
                                />
                            </div>

                            {/* Period Filter (Month & Year) */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Period</div>
                                <div className="d-flex flex-column gap-2">
                                    <Dropdown
                                        className="input-dd w-100"
                                        onChange={(e) => {
                                            setFilterValues((prev) => ({ ...prev, month: e.target.value, isChange: true }));
                                            if (e.target?.value === undefined) {
                                                getTeamOverViewList();
                                            }
                                        }}
                                        options={monthsOpt}
                                        placeholder="Company Age by Month"
                                        filter
                                        filterInputAutoFocus
                                        value={filterValues?.month}
                                        showClear
                                        optionLabel="label"
                                    />
                                    <Dropdown
                                        className="input-dd w-100"
                                        onChange={(e) => {
                                            setFilterValues((prev) => ({ ...prev, year: e.target.value, isChange: true }));
                                            if (e.target?.value === undefined) {
                                                getTeamOverViewList();
                                            }
                                        }}
                                        options={yearsOpt}
                                        showClear
                                        placeholder="Company Age By Year"
                                        filter
                                        filterInputAutoFocus
                                        value={filterValues?.year}
                                        optionLabel="label"
                                    />
                                </div>
                            </div>

                            {/* Attributes & Units */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Attributes</div>
                                <div className="d-flex flex-column gap-2">
                                    <MultiSelect
                                        className="input-dd w-100"
                                        onChange={(e) => {
                                            setFilterValues((prev) => ({ ...prev, "attribute": e.value, isChange: true }));
                                        }}
                                        options={options?.attribute}
                                        filter
                                        filterInputAutoFocus
                                        placeholder="Attribute"
                                        value={filterValues?.attribute}
                                        optionLabel="attribute_type_code"
                                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'attribute', filterValues?.department, () => { }, handleEvents)}
                                    />
                                    {filterValues?.attribute?.length > 0 && (
                                        <MultiSelect
                                            className="input-dd w-100"
                                            onChange={(e) => {
                                                setFilterValues((prev) => ({ ...prev, "unit": e.value, isChange: true }));
                                            }}
                                            options={options?.unit}
                                            filter
                                            filterInputAutoFocus
                                            placeholder="Unit"
                                            value={filterValues?.unit}
                                            optionLabel="attribute_unit_desc"
                                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'unit', filterValues?.business_unit, () => { }, handleEvents)}
                                        />
                                    )}
                                </div>
                            </div>

                            {/* Employee Status Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Employee Status</div>
                                <div className='sk-segment-control mb-3'>
                                    <button
                                        type="button"
                                        className={`sk-segment-btn ${filterValues?.isActiveBtn === 'active' ? 'active' : ''}`}
                                        onClick={() => setFilterValues(prevState => ({ ...prevState, isActiveBtn: 'active', apiCall: true }))}
                                    >
                                        Active
                                    </button>
                                    <button
                                        type="button"
                                        className={`sk-segment-btn ${filterValues?.isActiveBtn === 'inactive' ? 'active' : ''}`}
                                        onClick={() => setFilterValues(prevState => ({ ...prevState, isActiveBtn: 'inactive', apiCall: true }))}
                                    >
                                        In Active
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            getTeamOverViewList();
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TeamList;